import axios from 'axios'
import { Dialog } from 'vant'

export function getFetch(url) {
  return new Promise((resolve, reject) => {
    axios.defaults.headers['Content-Type'] = 'application/json'
    //axios.defaults.headers.common['X-AUTH-TOKEN'] = sessionStorage.site_current_token
    axios.get(url)
      .then(response => {
        resolve(JSON.stringify(response.data))
      })
      .catch((error) => {
        //console.log(error);
        var errorStatus = error.response.status;
        if (errorStatus == 401) {
          sessionStorage.site_current_token = '';
          location.reload();
        } else {
          Dialog.alert({
            message: errorStatus + '错误，请稍后再试',
          }).then(() => {
            //console.log(error);
          });
        }
        reject(error)
      })
  })
}
export function postFecth(url, params) {
  return new Promise((resolve, reject) => {
    axios.defaults.headers['Content-Type'] = 'application/json'
    axios.defaults.timeout = 10000;
    axios.post(url, params)
      .then(response => {
        resolve(JSON.stringify(response.data))
      })
      .catch((error) => {
        if (error.response) {
          //console.log('error.response',error.response)
        } else if (error.request) {
          //console.log('error.request',error.request)
          if (error.request.readyState == 4 && error.request.status == 0) {
            //重新请求
          }
        } else {
          //console.log('Error', error.message);
        }
        reject(error)
      });
  })
}

export function formFetch(url, params) {
  return new Promise((resolve, reject) => {
    axios.defaults.headers['Content-Type'] = 'application/json'
    //axios.defaults.headers.common['X-AUTH-TOKEN'] = sessionStorage.site_current_token
    axios.post(url, params)
      .then(response => {
        resolve(JSON.stringify(response.data))
      })
      .catch((error) => {
        //console.log(error);
        var errorStatus = error.response.status;
        if (errorStatus == 401) {
          sessionStorage.site_current_token = '';
          location.reload();
        } else {
          Dialog.alert({
            message: errorStatus + '错误，请稍后再试',
          }).then(() => {
            //console.log(error);
          });
        }
        reject(error)
      });
  })
}

export default {

  createOrder(postData)//生成订单编号
  {
    return formFetch('/ltxt/rest/ltxtSteamOrderController/createOrder',postData)
  },
  querySteamChargeitem(postData)//获取预约项目
  {
    return formFetch('/ltxt/rest/ltzxjkController/querySteamChargeitemnew',postData)
  },
  postupimg(postData)//上传图片
  {
    return formFetch('/ltxt/rest/ltzxjkController/postupimg',postData)
  },
  steamAddAppointment(postData)//添加蒸洗内容
  {
    return formFetch('/ltxt/rest/ltzxjkController/addSteamAppointment',postData)
  },
  getSteamAppointmentList(postData)
  {
    return formFetch('/ltxt/rest/ltzxjkController/getSteamAppointmentList',postData)
  },
  getSteamAssignmentDetail(postData)
  {
    return postFecth('/ltxt/rest/ltzxnbController/getSteamAssignmentDetail',postData)
  },
  cancelAppointment(postData)
  {
    return formFetch('/ltxt/rest/ltzxjkController/cancelAppointment',postData)
  },
  getSteamAppointmentDetail(postData)
  {
    return formFetch('/ltxt/rest/ltzxjkController/getSteamAppointmentDetail',postData)
  },
  querySteamWorkport(chargeItemzylb)
  {
    return formFetch('/ltxt/rest/ltzxjkController/querySteamWorkport?chargeItemzylb='+chargeItemzylb,{})
  },
  querySteamPdxxByWorkport(postData)
  {
    return formFetch('/ltxt/rest/ltzxjkController/querySteamPdxxByWorkport',postData)
  },
  hasSteamAppointmentenable(postData)
  {
    return formFetch('/ltxt/rest/ltzxjkController/hasSteamAppointmentenable',postData)
  },
  steamWechatPayCreateOrder(id,postData)
  {
    return formFetch('/ltxt/rest/wechatPayController/steamWechatPayCreateOrder?id='+id,postData)
  },
  getSteamAssignmentList(postData)
  {
    return formFetch('/ltxt/rest/ltzxjkController/getSteamAssignmentList',postData)
  },
  adjustAppointment(postData,optType,optMethod)
  {
    return formFetch('/ltxt/rest/ltzxjkController/adjustAppointmentInfo?&optType='+optType+"&optMethod="+optMethod,postData)
  },
  getMaxSteamChargeitemFee()
  {
    return formFetch('/ltxt/rest/ltzxjkController/getMaxSteamChargeitemFee',{})
  },
  payByCompany(postData)
  {
    return formFetch('/ltxt/rest/ltzxjkController/payByCompany',postData)
  },
  fetchCargoList(pzname,page,pageSize)
  {
    return getFetch('/ltxt/rest/ltxtSysGoodsController/listbyname/'+pzname+'/'+page+'/'+pageSize,)
  },
  fetchCargoLists(pzname)
  {
    return getFetch(`/ltxt/rest/ltxtSysGoodsController/listbynameV2?pzname=${pzname}`,)
  },
  //获取车辆是否绑定公司
  getController(chetouhaoName)
  {
    return getFetch(`/ltxt/rest/ltxtCcpdCtxxController/judgeIsCorporate?headstock=${chetouhaoName}`,)
  }
}

